/*
    Copyright (C) 2024 - Workforce Navigator - Southwest Airlines
*/
import { randomBytes } from 'crypto-browserify';

const generateUUID = () => {
  const buffer = randomBytes(16);

  // Set the version to 4
  buffer[6] = (buffer[6] & 0x0f) | 0x40;
  // Set the variant to RFC 4122
  buffer[8] = (buffer[8] & 0x3f) | 0x80;

  // Create the UUID parts
  const hexArray = Array.from(buffer).map(byte => byte.toString(16).padStart(2, '0'));

  // Manually create the UUID format
  return [
    // 8 characters
    hexArray.slice(0, 4).join(''),
    // 4 characters
    hexArray.slice(4, 6).join(''),
    // 4 characters (version)
    hexArray[6],
    // 4 characters
    hexArray[7],
    // 12 characters
    hexArray.slice(8, 12).join('')
  ].join('-');
};

export default generateUUID;
